export let selectionWithItemSingular = "MXtzb";
export let selectionWithItemsFirstPlural = "ajLHwc";
export let selectionWithItemsSecondPlural = "AIehbd";
export let selectionWithConversationSingular = "KSJolb";
export let selectionWithConversationsFirstPlural = "O1gAzb";
export let selectionWithConversationsSecondPlural = "Sp6ABd";
export default {selectionWithItemSingular,selectionWithItemsFirstPlural,selectionWithItemsSecondPlural,selectionWithConversationSingular,selectionWithConversationsFirstPlural,selectionWithConversationsSecondPlural};